import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { CSSProperties } from 'react';
import { DragIcon } from '@/assets/icons/icons';

const SortableRow = React.memo(function SortableRow({
  id,
  children,
  showDrag = true,
  className = 'dnd-row-class',
}: {
  id: string;
  children: React.ReactNode;
  showDrag?: boolean;
  className?: string;
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.85 : 1,
    width: '100%',
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <div className={className}>
        {showDrag && (
          <span
            aria-label='Drag'
            {...listeners}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              cursor: 'grab',
            }}
          >
            <DragIcon />
          </span>
        )}
        {children}
      </div>
    </div>
  );
});

export default SortableRow;
